import React from 'react';
const links = [{
  label: 'Terms',
  href: '#terms'
}, {
  label: 'Privacy Policy',
  href: '#privacy'
}, {
  label: 'Refund Policy',
  href: '#refund'
}, {
  label: 'Contact',
  href: 'mailto:hello@browinstructorready.com'
}];
export function SiteFooter() {
  return <footer className="bg-brand-charcoal px-5 py-12 text-brand-ivory/70 lg:px-8" data-id="element-204" data-mp="35chj3ypy1f09">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-205" data-mp="3a73x89netlo1">
        <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-206" data-mp="3f6giipymukoi">
          Brow Instructor <span className="text-brand-butter" data-id="element-207" data-mp="3o51z4fkjnpmn">Ready</span>™
        </p>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-208" data-mp="3o2ph62esdf9l">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-209" data-mp="1tr12m1cgvepq">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/45" data-id="element-210" data-mp="n8wpnlfbgzi">
        © 2026 Brow Instructor Ready™. A digital brow-education resource system. It does not provide
        professional licensing, accreditation or government-recognized certification. Always follow
        the manufacturer instructions for the professional products you use. Payments are processed
        in your local currency.
      </p>
    </footer>;
}